import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import VerticalPercentageBarChart from '../VerticalPercentageBarChart';
import HorizontalPercentageBarChart from '../HorizontalPercentageBarChart';
import DoughnutPercentageChart from '../DoughnutPercentageChart';
import LinePercentageChart from '../LinePercentageChart';
import EmptyResults from '../EmptyResults';
import AnalysisTable from '../AnalysisTable';
import StatisticsTable from './StatisticsTable';
import Tooltip from '../SelectiveQuestionResults/Tooltip';
import { ChartType } from '../../enum';

function NumericQuestionResults(props) {
  const { question, hasResponses } = props;
  const { showDataTable, data } = question;
  const { labels, percentages, counts, statistics } = data;
  const chartRef = useRef(null);
  const isEmpty = counts.every((count) => count === 0);

  function renderChart() {
    switch (question.chartType) {
      case ChartType.VERTICAL_BAR:
        return (
          <VerticalPercentageBarChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            Tooltip={Tooltip}
          />
        );
      case ChartType.HORIZONTAL_BAR:
        return (
          <HorizontalPercentageBarChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            Tooltip={Tooltip}
          />
        );
      case ChartType.PIE:
        return (
          <DoughnutPercentageChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            Tooltip={Tooltip}
          />
        );
      case ChartType.LINE:
        return (
          <LinePercentageChart
            data={percentages}
            extraDatasets={[{ data: counts, hidden: true }]}
            labels={labels}
            Tooltip={Tooltip}
          />
        );
      default:
        return null;
    }
  }

  if (isEmpty) <EmptyResults hasResponses={hasResponses} />;

  return (
    <div className="engage-results-engagement-screen__chart-content">
      <div className="engage-results-engagement-screen__chart-content__chart" ref={chartRef}>
        {renderChart()}
      </div>
      {showDataTable && (
        <>
          <div className="engage-results-engagement-screen__chart-content__stats">
            <h4 className="engage-results-engagement-screen__chart-content__subtitle">
              Statistics
            </h4>
            <StatisticsTable statistics={statistics} />
          </div>
          <div className="engage-results-engagement-screen__chart-content__analysis">
            <h4 className="engage-results-engagement-screen__chart-content__subtitle">Results</h4>
            <AnalysisTable labels={labels} percentages={percentages} counts={counts} />
          </div>
        </>
      )}
    </div>
  );
}

NumericQuestionResults.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    chartType: PropTypes.string.isRequired,
    showDataTable: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      labels: PropTypes.arrayOf(PropTypes.string),
      counts: PropTypes.arrayOf(PropTypes.number),
      percentages: PropTypes.arrayOf(PropTypes.number),
      statistics: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
        median: PropTypes.number,
        mean: PropTypes.number,
        mode: PropTypes.number,
        stdDev: PropTypes.number,
      }),
    }),
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
};

export default NumericQuestionResults;
